<div class="payment-history-container">
  <div class="history-header">
    <h1>Payment History</h1>
    <p class="subtitle">View your past tourist development tax payments</p>
  </div>

  <div *ngIf="loading" class="loading-container">
    <mat-spinner diameter="50"></mat-spinner>
    <p>Loading payment history...</p>
  </div>

  <mat-card *ngIf="error && !loading" class="error-card">
    <mat-card-content>
      <mat-icon color="warn">error</mat-icon>
      <p>{{ error }}</p>
      <button mat-raised-button color="primary" (click)="loadPayments()">Retry</button>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="!loading && !error" class="history-card">
    <mat-card-content>
      <div *ngIf="dataSource.data.length === 0" class="empty-state">
        <mat-icon>history</mat-icon>
        <h3>No Payment History</h3>
        <p>You haven't made any payments yet.</p>
        <button mat-raised-button color="primary" routerLink="/app/payments">
          Make a Payment
        </button>
      </div>

      <div *ngIf="dataSource.data.length > 0">
        <table mat-table [dataSource]="dataSource" matSort>

          <ng-container matColumnDef="confirmationNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Confirmation #</th>
            <td mat-cell *matCellDef="let payment">
              <a [routerLink]="['/app/payments/confirmation', payment.confirmationNumber]">
                {{ payment.confirmationNumber }}
              </a>
            </td>
          </ng-container>

          <ng-container matColumnDef="paymentDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
            <td mat-cell *matCellDef="let payment">{{ payment.paymentDate | date: 'MMM d, y h:mm a' }}</td>
          </ng-container>

          <ng-container matColumnDef="returns">
            <th mat-header-cell *matHeaderCellDef>Returns</th>
            <td mat-cell *matCellDef="let payment">
              <span class="returns-summary">{{ getReturnsSummary(payment) }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="totalPaid">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
            <td mat-cell *matCellDef="let payment" class="amount-cell">
              {{ payment.totalPaid | currency }}
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let payment">
              <span class="status-badge" [style.color]="getStatusColor(payment.status)">
                {{ payment.status }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let payment">
              <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="viewDetails(payment)">
                  <mat-icon>visibility</mat-icon>
                  <span>View Details</span>
                </button>
                <button mat-menu-item (click)="downloadReceipt(payment.id, $event)">
                  <mat-icon>download</mat-icon>
                  <span>Download Receipt</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"
              (click)="viewDetails(row)" class="clickable-row"></tr>
        </table>

        <mat-paginator [length]="totalCount" [pageSize]="20" [pageSizeOptions]="[10, 20, 50]"
                       (page)="loadPayments($event.pageIndex, $event.pageSize)">
        </mat-paginator>
      </div>
    </mat-card-content>
  </mat-card>
</div>
